import { LookEntity, usersKeys } from '@seaters-app/constants';
import { useFetchFanFGSeats, queryClient } from '@seaters-app/data-access';

interface WalletInfo {
  showWalletInfo: boolean;
  availableTickets: number;
  hasWalletTicketsLimit: boolean;
}

export function useWalletInfo(fanGroupId?: string): WalletInfo {
  const lookEntity = queryClient.getQueryData<LookEntity>(usersKeys.look());
  const { data: seats } = useFetchFanFGSeats(fanGroupId ?? '');

  const hasWalletTicketsLimit = lookEntity?.properties?.hasWalletTicketsLimit;
  const seatsLimit = seats?.seatsLimit ?? 0;

  // Show wallet info if wallet tickets limit is enabled
  const showWalletInfo = !!hasWalletTicketsLimit;

  return {
    showWalletInfo,
    availableTickets: hasWalletTicketsLimit ? seatsLimit : 0,
    hasWalletTicketsLimit: !!hasWalletTicketsLimit,
  };
}
